export default __webpack_public_path__ + "static/media/ECD_Connect_alien.f6934c07.svg";